import NewStdReport from "./NewStdReport";
import ReportsTable from "../ReportsTable";

const StdReportGeneration = ({ reports }) => {

    return (
        <>
            <button
                className="btn btn-primary fs--1 mb-4"
                type="button"
                data-toggle="modal"
                data-target="#AddNewStandardReportModal">
                Create
                <i className="fas fa-plus-circle ml-2"></i>
            </button>
            <NewStdReport />
            <ReportsTable reports={reports} />
        </>
    );
}
export default StdReportGeneration;